import {StaticDispatch} from '~/components/hoc/with-session-state';
import {navigate} from '~/lib/root-navigation';
import {serviceRequestUpdate} from '~/actions';
import metrics from '~/lib/metrics';

const handler = ({
  actions,
  rob_id,
  license,
  status,
  rob_status,
  rob_invoicing_status,
}) => {
  console.log(
    'Notification received',
    actions,
    rob_id,
    license,
    status,
    rob_status,
    rob_invoicing_status,
  );

  if (actions) {
    for (const action of actions) {
      if (action.type === 'OPEN_ROB_REQUEST') {
        navigate('Request', {...action.data, v: new Date().getTime()});

        metrics.addNotification({
          type: 'OPEN_ROB_REQUEST',
          data: action.data,
        });
      }
    }

    return;
  }

  metrics.addNotification({
    type: 'ROB_UPDATE',
    data: {
      rob_id,
      status,
    },
  });

  StaticDispatch(
    serviceRequestUpdate({
      rob_id,
      license,
      status,
      rob_status,
      rob_invoicing_status,
    }),
  );
};

export default handler;
